import React from 'react';
import {
  Grid,
  Theme,
} from '@material-ui/core';
import {
  makeStyles,
} from '@material-ui/styles';
import { ColorProperty } from 'csstype';

import { ButtonPreview, VideoPreview } from '../../components';

const useStyles = makeStyles(({ palette }: Theme) => ({
  title: {
    color: palette.text.secondary,
    fontFamily: 'Roboto',
    fontSize: '12px',
  },
  content: {
    border: '2px dashed #ccc',
    height: '330px',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '1px',
  },
  item: {
    display: 'flex',
    justifyContent: 'center',
  },
}), { name: 'Preview' });

type Props = {
  buttonBgActive: ColorProperty;
  buttonBgInactive: ColorProperty;
  buttonFg: ColorProperty;
  buttonStyle: string;
  playerBaseColor: ColorProperty;
  playerAccentColor: ColorProperty;
};

const Preview = ({
  buttonBgActive,
  buttonBgInactive,
  buttonFg,
  buttonStyle,
  playerBaseColor,
  playerAccentColor,
}: Props) => {
  const classes = useStyles({ playerBaseColor, playerAccentColor });

  return (
    <Grid container>
      <Grid item xs={12} className={classes.title}>
        Preview
      </Grid>
      <Grid item xs={12} container spacing={1} className={classes.content}>
        <Grid item xs={12} className={classes.item}>
          <VideoPreview
            baseColor={playerBaseColor}
            accentColor={playerAccentColor}
          />
        </Grid>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} className={classes.item}>
            <ButtonPreview
              backgroundColor={buttonBgActive}
              stringStyle={buttonStyle}
              fontColor={buttonFg}
            >
              Active Button
            </ButtonPreview>
          </Grid>
          <Grid item xs={12} className={classes.item}>
            <ButtonPreview
              backgroundColor={buttonBgInactive}
              stringStyle={buttonStyle}
              fontColor={buttonFg}
            >
              Inactive Button
            </ButtonPreview>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Preview;
